package app.nestbridge.feature.children.ui

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.tooling.preview.Preview
import androidx.compose.ui.tooling.preview.PreviewParameter
import com.karawek.core.ui.theme.CoreTheme
import com.karawek.core.ui.theme.CoreTypography
import com.karawek.core.ui.theme.ThemeMode
import com.karawek.core.ui.theme.ThemeModeProvider
import app.nestbridge.feature.children.screen.ChildrenScreen
import app.nestbridge.feature.children.screen.ChildrenState
import app.nestbridge.ui.theme.NestBridgeTheme
import com.slack.circuit.codegen.annotations.CircuitInject
import software.amazon.lastmile.kotlin.inject.anvil.AppScope

@CircuitInject(
    screen = ChildrenScreen::class,
    scope = AppScope::class,
)
@Composable
fun ChildrenUi(
    state: ChildrenState,
    modifier: Modifier = Modifier,
) {
    Box(
        modifier = modifier.fillMaxSize(),
        contentAlignment = Alignment.Center,
    ) {
        Column(
            horizontalAlignment = Alignment.CenterHorizontally,
            verticalArrangement = Arrangement.Center,
        ) {
            androidx.compose.material3.Text(
                text = "Children",
                style = CoreTypography.headline,
                color = CoreTheme.colors.textPrimary,
            )
        }
    }
}

// region Previews

@Preview
@Composable
private fun ChildrenPreview(
    @PreviewParameter(ThemeModeProvider::class) themeMode: ThemeMode,
) {
    NestBridgeTheme(themeMode = themeMode) {
        ChildrenUi(
            state = ChildrenState(
                eventSink = {},
            ),
        )
    }
}

// endregion
